import { X, Edit } from 'lucide-react';
import React, { useState } from 'react';


const ContactInfo = ({ onClose, isOpen,user }) => {
 
  

  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center transition-opacity duration-150">
      <div 
        className="relative bg-white rounded-lg w-full max-w-md mx-4"
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-xl font-semibold text-gray-900">Contact Information</h3>
          <div className="flex items-center space-x-2">
          <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-4 space-y-4">
        <>
              <div className="flex justify-between">
                <span className="text-gray-600">Primary Email:</span>
                <span className="font-medium">{user?.email}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Secondary Email:</span>
                <span className="font-medium">{user?.secondary_email || 'N/A'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Primary Phone:</span>
                <span className="font-medium">{user?.primary_phone}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Secondary Phone:</span>
                <span className="font-medium">{user?.secondary_phone || 'N/A'}</span>
              </div>
            </>
        </div>

        {/* Footer */}
        <div className="p-4 border-t">
        <button
              onClick={onClose}
              className="w-full py-2 px-4 bg-[#1330C5] text-white rounded-full hover:opacity-60 transition-colors duration-300"
            >
              Close
            </button>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;